export const FRONT_DATE_FORMAT = 'DD.MM.YYYY'
export const BACK_DATE_FORMAT = 'YYYY-MM-DD'
export const BACK_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
